export const SALES_GATED_LOCATIONS = ['United States', 'Canada', 'United Kingdom'];

export const isSalesGatedLocation = (user) => SALES_GATED_LOCATIONS.includes(user?.options?.location);

export const COUNTRIES = [
	{ name: 'Afghanistan' },
	{ name: 'Albania' },
	{ name: 'Algeria' },
	{ name: 'Andorra' },
	{ name: 'Angola' },
	{ name: 'Antigua & Barbuda' },
	{ name: 'Argentina' },
	{ name: 'Armenia' },
	{ name: 'Australia' },
	{ name: 'Austria' },
	{ name: 'Azerbaijan' },
	{ name: 'Bahamas' },
	{ name: 'Bahrain' },
	{ name: 'Bangladesh' },
	{ name: 'Barbados' },
	{ name: 'Belarus' },
	{ name: 'Belgium' },
	{ name: 'Belize' },
	{ name: 'Benin' },
	{ name: 'Bhutan' },
	{ name: 'Bolivia' },
	{ name: 'Bosnia & Herzegovina' },
	{ name: 'Botswana' },
	{ name: 'Brazil' },
	{ name: 'Brunei' },
	{ name: 'Bulgaria' },
	{ name: 'Burkina Faso' },
	{ name: 'Burundi' },
	{ name: 'Cabo Verde' },
	{ name: 'Cambodia' },
	{ name: 'Cameroon' },
	{ name: 'Canada' },
	{ name: 'Central African Republic' },
	{ name: 'Chad' },
	{ name: 'Chile' },
	{ name: 'China' },
	{ name: 'Colombia' },
	{ name: 'Comoros' },
	{ name: 'Congo' },
	{ name: 'Costa Rica' },
	{ name: "Côte d'Ivoire" },
	{ name: 'Croatia' },
	{ name: 'Cuba' },
	{ name: 'Cyprus' },
	{ name: 'Czech Republic' },
	{ name: 'Denmark' },
	{ name: 'Djibouti' },
	{ name: 'Dominica' },
	{ name: 'Dominican Republic' },
	{ name: 'DR Congo' },
	{ name: 'Ecuador' },
	{ name: 'Egypt' },
	{ name: 'El Salvador' },
	{ name: 'Equatorial Guinea' },
	{ name: 'Eritrea' },
	{ name: 'Estonia' },
	{ name: 'Eswatini' },
	{ name: 'Ethiopia' },
	{ name: 'Fiji' },
	{ name: 'Finland' },
	{ name: 'France' },
	{ name: 'Gabon' },
	{ name: 'Gambia' },
	{ name: 'Georgia' },
	{ name: 'Germany' },
	{ name: 'Ghana' },
	{ name: 'Greece' },
	{ name: 'Grenada' },
	{ name: 'Guatemala' },
	{ name: 'Guinea' },
	{ name: 'Guinea-Bissau' },
	{ name: 'Guyana' },
	{ name: 'Haiti' },
	{ name: 'Holy See' },
	{ name: 'Honduras' },
	{ name: 'Hungary' },
	{ name: 'Iceland' },
	{ name: 'India' },
	{ name: 'Indonesia' },
	{ name: 'Iran' },
	{ name: 'Iraq' },
	{ name: 'Ireland' },
	{ name: 'Israel' },
	{ name: 'Italy' },
	{ name: 'Jamaica' },
	{ name: 'Japan' },
	{ name: 'Jordan' },
	{ name: 'Kazakhstan' },
	{ name: 'Kenya' },
	{ name: 'Kiribati' },
	{ name: 'Kuwait' },
	{ name: 'Kyrgyzstan' },
	{ name: 'Laos' },
	{ name: 'Latvia' },
	{ name: 'Lebanon' },
	{ name: 'Lesotho' },
	{ name: 'Liberia' },
	{ name: 'Libya' },
	{ name: 'Liechtenstein' },
	{ name: 'Lithuania' },
	{ name: 'Luxembourg' },
	{ name: 'Madagascar' },
	{ name: 'Malawi' },
	{ name: 'Malaysia' },
	{ name: 'Maldives' },
	{ name: 'Mali' },
	{ name: 'Malta' },
	{ name: 'Marshall Islands' },
	{ name: 'Mauritania' },
	{ name: 'Mauritius' },
	{ name: 'Mexico' },
	{ name: 'Micronesia' },
	{ name: 'Moldova' },
	{ name: 'Monaco' },
	{ name: 'Mongolia' },
	{ name: 'Montenegro' },
	{ name: 'Morocco' },
	{ name: 'Mozambique' },
	{ name: 'Myanmar' },
	{ name: 'Namibia' },
	{ name: 'Nauru' },
	{ name: 'Nepal' },
	{ name: 'Netherlands' },
	{ name: 'New Zealand' },
	{ name: 'Nicaragua' },
	{ name: 'Niger' },
	{ name: 'Nigeria' },
	{ name: 'North Korea' },
	{ name: 'North Macedonia' },
	{ name: 'Norway' },
	{ name: 'Oman' },
	{ name: 'Pakistan' },
	{ name: 'Palau' },
	{ name: 'Panama' },
	{ name: 'Papua New Guinea' },
	{ name: 'Paraguay' },
	{ name: 'Peru' },
	{ name: 'Philippines' },
	{ name: 'Poland' },
	{ name: 'Portugal' },
	{ name: 'Qatar' },
	{ name: 'Romania' },
	{ name: 'Russia' },
	{ name: 'Rwanda' },
	{ name: 'Saint Kitts & Nevis' },
	{ name: 'Saint Lucia' },
	{ name: 'Samoa' },
	{ name: 'San Marino' },
	{ name: 'Sao Tome & Principe' },
	{ name: 'Saudi Arabia' },
	{ name: 'Senegal' },
	{ name: 'Serbia' },
	{ name: 'Seychelles' },
	{ name: 'Sierra Leone' },
	{ name: 'Singapore' },
	{ name: 'Slovakia' },
	{ name: 'Slovenia' },
	{ name: 'Solomon Islands' },
	{ name: 'Somalia' },
	{ name: 'South Africa' },
	{ name: 'South Korea' },
	{ name: 'South Sudan' },
	{ name: 'Spain' },
	{ name: 'Sri Lanka' },
	{ name: 'St. Vincent & Grenadines' },
	{ name: 'State of Palestine' },
	{ name: 'Sudan' },
	{ name: 'Suriname' },
	{ name: 'Sweden' },
	{ name: 'Switzerland' },
	{ name: 'Syria' },
	{ name: 'Tajikistan' },
	{ name: 'Tanzania' },
	{ name: 'Thailand' },
	{ name: 'Timor-Leste' },
	{ name: 'Togo' },
	{ name: 'Tonga' },
	{ name: 'Trinidad & Tobago' },
	{ name: 'Tunisia' },
	{ name: 'Turkey' },
	{ name: 'Turkmenistan' },
	{ name: 'Tuvalu' },
	{ name: 'Uganda' },
	{ name: 'Ukraine' },
	{ name: 'United Arab Emirates' },
	{ name: 'United Kingdom' },
	{ name: 'United States' },
	{ name: 'Uruguay' },
	{ name: 'Uzbekistan' },
	{ name: 'Vanuatu' },
	{ name: 'Venezuela' },
	{ name: 'Vietnam' },
	{ name: 'Yemen' },
	{ name: 'Zambia' },
	{ name: 'Zimbabwe' },
];

export const US_STATES = [
	{ name: 'Alabama', abv: 'AL' },
	{ name: 'Alaska', abv: 'AK' },
	{ name: 'Arizona', abv: 'AZ' },
	{ name: 'Arkansas', abv: 'AR' },
	{ name: 'California', abv: 'CA' },
	{ name: 'Colorado', abv: 'CO' },
	{ name: 'Connecticut', abv: 'CT' },
	{ name: 'Delaware', abv: 'DE' },
	{ name: 'District of Columbia', abv: 'DC' },
	{ name: 'Florida', abv: 'FL' },
	{ name: 'Georgia', abv: 'GA' },
	{ name: 'Hawaii', abv: 'HI' },
	{ name: 'Idaho', abv: 'ID' },
	{ name: 'Illinois', abv: 'IL' },
	{ name: 'Indiana', abv: 'IN' },
	{ name: 'Iowa', abv: 'IA' },
	{ name: 'Kansas', abv: 'KS' },
	{ name: 'Kentucky', abv: 'KY' },
	{ name: 'Louisiana', abv: 'LA' },
	{ name: 'Maine', abv: 'ME' },
	{ name: 'Maryland', abv: 'MD' },
	{ name: 'Massachusetts', abv: 'MA' },
	{ name: 'Michigan', abv: 'MI' },
	{ name: 'Minnesota', abv: 'MN' },
	{ name: 'Mississippi', abv: 'MS' },
	{ name: 'Missouri', abv: 'MO' },
	{ name: 'Montana', abv: 'MT' },
	{ name: 'Nebraska', abv: 'NE' },
	{ name: 'Nevada', abv: 'NV' },
	{ name: 'New Hampshire', abv: 'NH' },
	{ name: 'New Jersey', abv: 'NJ' },
	{ name: 'New Mexico', abv: 'NM' },
	{ name: 'New York', abv: 'NY' },
	{ name: 'North Carolina', abv: 'NC' },
	{ name: 'North Dakota', abv: 'ND' },
	{ name: 'Ohio', abv: 'OH' },
	{ name: 'Oklahoma', abv: 'OK' },
	{ name: 'Oregon', abv: 'OR' },
	{ name: 'Pennsylvania', abv: 'PA' },
	{ name: 'Rhode Island', abv: 'RI' },
	{ name: 'South Carolina', abv: 'SC' },
	{ name: 'South Dakota', abv: 'SD' },
	{ name: 'Tennessee', abv: 'TN' },
	{ name: 'Texas', abv: 'TX' },
	{ name: 'Utah', abv: 'UT' },
	{ name: 'Vermont', abv: 'VT' },
	{ name: 'Virginia', abv: 'VA' },
	{ name: 'Washington', abv: 'WA' },
	{ name: 'West Virginia', abv: 'WV' },
	{ name: 'Wisconsin', abv: 'WI' },
	{ name: 'Wyoming', abv: 'WY' },
];
